/**
 * A simple function to format object to GET parameters.
 */
function getStringifiedParams(object) {
  var keys = Object.keys(object);
  var params = keys.filter(function (key) {
    return object[key] !== undefined;
  }).map(function (key) {
    return "".concat(key, "=").concat(object[key]);
  });
  return params.length > 0 ? "?".concat(params.join('&')) : '';
}

export { getStringifiedParams };
